import config from '@core/config';

const useConfig = () => config;

export default useConfig;
